export default __webpack_public_path__ + "static/media/Click3.dbdd5056.mp3";